var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityComplianceAndAuditingServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.251465,
    y: 0.0564575,
    width: 72.5033,
    height: 72.5033,
    rx: 10.3576,
    fill: "#43CC74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.062 55.6941C45.9659 55.6941 45.8697 55.6752 45.7794 55.6373C45.4328 55.4902 37.3228 51.9858 37.3228 44.8225V38.7356C37.3228 38.4225 37.5223 38.1457 37.818 38.0452L45.8289 35.3404C45.9804 35.2894 46.145 35.2894 46.295 35.3404L54.306 38.0452C54.6017 38.1443 54.8012 38.4225 54.8012 38.7356V44.8225C54.8012 51.9858 46.6912 55.4902 46.3446 55.6373C46.2543 55.6752 46.1581 55.6941 46.062 55.6941ZM38.7793 39.26V44.8225C38.7793 50.334 44.6856 53.5006 46.062 54.1633C47.437 53.4991 53.3447 50.3195 53.3447 44.8225V39.26L46.062 36.7999L38.7793 39.26Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.388411
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3335 48.4112C45.3204 48.4112 45.3059 48.4112 45.2942 48.4097C45.0859 48.3981 44.8951 48.3005 44.7655 48.1373L41.8524 44.496C41.6019 44.1814 41.6514 43.724 41.966 43.472C42.2821 43.2244 42.738 43.274 42.99 43.5857L45.3932 46.5905L49.9158 42.0694C50.1998 41.7854 50.6615 41.7854 50.9456 42.0694C51.2296 42.3534 51.2296 42.8152 50.9456 43.0992L45.8477 48.1971C45.7122 48.334 45.5258 48.4112 45.3335 48.4112Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.388411
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7902 32.3899H24.9421C22.131 32.3899 19.8442 30.1031 19.8442 27.292C19.8442 24.4809 22.131 22.1941 24.9421 22.1941H46.7902C49.6013 22.1941 51.8881 24.4809 51.8881 27.292C51.8881 30.1031 49.6013 32.3899 46.7902 32.3899ZM24.9421 23.6506C22.9336 23.6506 21.3008 25.2834 21.3008 27.292C21.3008 29.3006 22.9336 30.9333 24.9421 30.9333H46.7902C48.7988 30.9333 50.4316 29.3006 50.4316 27.292C50.4316 25.2834 48.7988 23.6506 46.7902 23.6506H24.9421Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.388411
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6814 41.1289H24.9421C22.131 41.1289 19.8442 38.8422 19.8442 36.0311C19.8442 34.6706 20.3744 33.3918 21.3386 32.4276C22.3029 31.4633 23.5817 30.9332 24.9421 30.9332H46.7902C47.9292 30.9332 49.0027 31.2988 49.8897 31.9906C50.2073 32.2382 50.2641 32.6956 50.0165 33.0131C49.7688 33.3292 49.3115 33.386 48.994 33.1398C48.3647 32.649 47.603 32.3897 46.7902 32.3897H24.9421C23.9721 32.3897 23.0574 32.7699 22.3684 33.4574C21.6795 34.1448 21.3008 35.061 21.3008 36.0311C21.3008 38.0396 22.9336 39.6724 24.9421 39.6724H33.6814C34.0834 39.6724 34.4096 39.9987 34.4096 40.4007C34.4096 40.8027 34.0834 41.1289 33.6814 41.1289Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.388411
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6814 49.868H24.9421C22.131 49.868 19.8442 47.5813 19.8442 44.7701C19.8442 43.4097 20.3744 42.1309 21.3386 41.1667C22.3029 40.2024 23.5817 39.6722 24.9421 39.6722H33.6814C34.0834 39.6722 34.4096 39.9985 34.4096 40.4005C34.4096 40.8025 34.0834 41.1288 33.6814 41.1288H24.9421C23.9721 41.1288 23.0574 41.5089 22.3684 42.1964C21.6795 42.8839 21.3008 43.8001 21.3008 44.7701C21.3008 46.7787 22.9336 48.4115 24.9421 48.4115H33.6814C34.0834 48.4115 34.4096 48.7377 34.4096 49.1398C34.4096 49.5418 34.0834 49.868 33.6814 49.868Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.388411
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityComplianceAndAuditingServiceIcon);
export default __webpack_public_path__ + "static/media/SecurityComplianceAndAuditingServiceIcon.33fc8ac5e771c81710b98a6cf67e3814.svg";
export { ForwardRef as ReactComponent };